( function($) {
  function load_more_func( e, el, item ) {
    e.preventDefault();
  
    // disable load more button for accidental double clicks
    el.prop( 'disabled', true );
  
    var button = el,
        buttonText = el.text(),
        max_page = el.attr( 'max-pages' ),
        current_page = el.attr( 'current-page' ),
        data = {
          'action': el.attr( 'action' ),
          'posts_per_page': el.attr( 'posts-per-page' ),
          'taxonomy': el.attr( 'taxonomy' ),
          // 'search_value': el.attr( 'search' ),
          // 'offset': el.attr( 'offset' ),
          'page': current_page,
          'site': el.attr( 'multisite' )
        };
  
    var container = document.getElementById( 'loadMore' );

		console.log( data );

    $.ajax( {
      url : data.site + '/wp-admin/admin-ajax.php', // AJAX handler
      data: data,
      type: 'POST',

      beforeSend: function( xhr ) {
        button.text( 'loading...' );
      },
      
      success: function( html ) {
        el.prop( 'disabled', false );
  
        button.text( '' );
        button.append( '<span>' + buttonText + '</span> <i class="fa-solid fa-chevron-down"></i>' );
  
        if( html ) {
          item.append( html );
          
          button.attr( 'current-page', ++current_page );
          button.text = buttonText;
  
          if( current_page > max_page ) {
            container.style.display = 'none'; // if last page
          }
        }
        
        else {
          container.style.display = 'none'; // if no data
        }
      }
    } );
  }

  $( '.load-more-posts' ).click( function(e) {
    load_more_func( e, $( this ), $( '.blog-list-container' ) );
  } );
} )( jQuery );
  